var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CrudMultiSelect',{attrs:{"value":_vm.value,"endpoint":"/data-api/account","searchFields":['name'],"queryParams":_vm.queryParams,"trackBy":"id","label":"name","placeholder":"Account name / ID","multiple":true},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }